import color from "color";
import DefaultTheme from "../DefaultTheme";
import { black, white, pinkA100 } from "../Utils/colors";

const DarkTheme = {
  ...DefaultTheme,
  dark: true,
  mode: "adaptive",
  colors: {
    ...DefaultTheme.colors,
    primary: "#BB86FC",
    accent: pinkA100,
    background: "#121212",
    surface: "#121212",
    error: "#CF6679",
    onBackground: "#FFFFFF",
    onSurface: "#FFFFFF",
    text: white,
    activeMenuLink: white,
    disabled: color(white)
      .alpha(0.38)
      .rgb()
      .string(),
    placeholder: color(white)
      .alpha(0.54)
      .rgb()
      .string(),
    backdrop: color(black)
      .alpha(0.5)
      .rgb()
      .string(),
    notification: pinkA100
  }
};

export default DarkTheme;
